import { Injector } from '@angular/core';
import { MenuService } from 'kmm-corp-api';

export class ViewColumnModel {

   ACAO = <any>{};
   _menuService: MenuService;

   constructor(
      protected _injector: Injector
   ) {
      this._menuService = this._injector.get(MenuService);
   }

   isGroupRow(row): boolean {
      if ('aggregates' in row && 'key' in row) {
         return true;
      } else {
         return false;
      }
   }

   setAcao(acoes: Array<string>) {
      this.ACAO = {};
      acoes.forEach(a => {
         this.ACAO[a] = this._menuService.possuiAcao(a);
      });
   }

}
